import React, { useEffect, useState } from "react";
import Marquee from "react-fast-marquee";

const Album = () => {
  const [advocate, setAdvocate] = useState([]);

  useEffect(() => {
    fetch("https://lawacademyadmin.icicle.dev/api/advocateList")
      .then((res) => res.json())
      .then((data) => {
        setAdvocate(data);
      });
  }, []);

  // css
  const rowStyle = {
    display: "inline-flex",
    gap: "",
    height: "270px",
  };
  return (
    <>
      <div>
        <div
          className="container"
          style={{
            padding: "20px 0px",
            textAlign: "center",
          }}
        >
          <div
            style={{
              border: "2px solid rgb(255, 176, 18)",
              width: "60px",
              margin: "0 auto",
              marginBottom: "10px",
            }}
          />
          <span style={{ fontWeight: "bolder", fontSize: "30px" }}>Advocate List</span>
        </div>
        <Marquee speed={100}>
          <div data-aos="fade-up" className="row" style={rowStyle}>
            {advocate.map((item, index) => (
              <div key={index}>
                <div
                  style={{
                    width: "250px",
                    display: "flex",
                    flexDirection: "column",
                    placeItems: "center",
                  }}
                >
                  <img
                    style={{ objectFit: "fill" }}
                    className="student_opportunity_img"
                    src={`https://lawacademyadmin.icicle.dev/${item?.image}`}
                    alt="Name 1"
                  />
                  <h4
                    className="text-center"
                    style={{
                      margin: "10px 0",
                      color: "#1C245B",
                      fontWeight: 600,
                    }}
                  >
                    {item.name}
                  </h4>
                </div>
              </div>
            ))}
          </div>
        </Marquee>
      </div>
    </>
  );
};

export default Album;
